import React from 'react'
import {
    DataGridPro,
    ptBR
} from '@mui/x-data-grid-pro';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ptBR as corePtBR } from '@mui/material/locale';
import { Box } from '@mui/material';

const theme = createTheme({
    palette: {
        primary: { main: '#21446C' },
    },
}, ptBR, corePtBR);

const GraphTable = ({ rows, columns }) => {
    return (
        <Box sx={{ width: '100%', padding: '0.5rem 0', height: '100%', flex: 1 }}>
            <ThemeProvider theme={theme}>
                <DataGridPro
                    sx={{background:'white'}}
                    columns={columns}
                    rows={rows}
                    disableSelectionOnClick
                    density={'compact'}
                />
            </ThemeProvider>
        </Box>
    )
}

export default GraphTable